import React from 'react';
import PropTypes from 'prop-types';
import { useFooterCTAs } from '../../../hooks';
import { FOOTER_CTA_TYPES } from '../../../global-constants';
import MyCars from './MyCars';
import CompareCheckbox from './CompareCheckbox';
import DetailsButton from './DetailsButton';
import vehiclePropType from '../../../propTypes/vehiclePropType';

const Footer = ({
	vehicle,
	containsVehicle,
	selected,
	setSelected,
	compareVehicles
}) => {
	const { uuid, link } = vehicle;
	const { isCTARemoved, shouldRemoveBothMyCarsCTAs, shouldShowCompare } =
		useFooterCTAs();

	return (
		<>
			{shouldShowCompare && (
				<CompareCheckbox
					uuid={uuid}
					containsVehicle={containsVehicle}
					selected={selected}
					setSelected={setSelected}
					compareVehicles={compareVehicles}
				/>
			)}
			<MyCars
				vehicle={vehicle}
				shouldRemoveBothMyCarsCTAs={shouldRemoveBothMyCarsCTAs}
			/>
			{!isCTARemoved(FOOTER_CTA_TYPES.DETAILS) && (
				<DetailsButton uuid={uuid} link={link} title={vehicle.title} />
			)}
		</>
	);
};

Footer.propTypes = {
	vehicle: vehiclePropType.isRequired,
	containsVehicle: PropTypes.func.isRequired,
	selected: PropTypes.bool.isRequired,
	setSelected: PropTypes.func.isRequired,
	compareVehicles: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default Footer;
